import script from "./bindMachine.vue?vue&type=script&setup=true&lang=js"
export * from "./bindMachine.vue?vue&type=script&setup=true&lang=js"

import "./bindMachine.vue?vue&type=style&index=0&id=bed3f322&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bed3f322"]])

export default __exports__